import { Badge } from "@/components/ui/badge";
import { UserStatus } from "@/interfaces/profile";
import { CheckCircle2, Ban, Trash2, PauseCircle } from "lucide-react";

const statusConfig = {
  [UserStatus.ACTIVE]: {
    label: "Active",
    icon: CheckCircle2,
    className: "border-emerald-200 text-emerald-700 bg-emerald-50",
  },
  [UserStatus.SUSPENDED]: {
    label: "Suspended",
    icon: PauseCircle,
    className: "border-amber-200 text-amber-700 bg-amber-50",
  },
  [UserStatus.DELETED]: {
    label: "Deleted",
    icon: Trash2,
    className: "border-gray-200 text-gray-500 bg-gray-50",
  },
  [UserStatus.BANNED]: {
    label: "Banned",
    icon: Ban,
    className: "border-red-200 text-red-700 bg-red-50",
  },
} as const;

export function StatusBadge({ status }: { status: UserStatus }) {
  const config = statusConfig[status];
  const Icon = config.icon;

  return (
    <Badge
      variant="outline"
      className={`flex items-center gap-1 px-2 py-0.5 text-xs font-medium ${config.className}`}
    >
      <Icon className="w-3.5 h-3.5 opacity-80" />
      {config.label}
    </Badge>
  );
}
